import jsPDF from "jspdf";
import { registerRoboto } from "../../fonts/registerRoboto"; // file that loads Roboto, Caveat, etc.
import { fontStyles, labelColors, valueColors, lineColors } 
  from "../../components/fontStylesColors";



  export const generatePDF = async ({
  formData,
  formData1,
  todos,
  selectedImages,
  photos,
  model,
}) => {
	  
	   
	  
    
    
	
const doc = new jsPDF();
registerRoboto(doc);
const gridsPerPage = 8;
const rows = 4;
const cols = 2;
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

// Define spacious margins
const marginX = 13; // Left & Right margin
const marginY = 15; // Top & Bottom margin

// Adjust grid size: Increased width slightly (+2px) while keeping height the same
const gridWidth = (pageWidth - 2 * marginX) / cols + 3; // Slightly increased width
const gridHeight = (pageHeight - 2 * marginY) / rows-6; // Height remains unchanged


let gridCount = 0;



	 const { font, size, color } = fontStyles[0];
  const labelColor = labelColors[0];
  const valueColor = valueColors[0];
  const lineColor = lineColors[0];



todos.forEach((todo, index) => {
  const currentPage = Math.floor(gridCount / gridsPerPage);
  const gridIndex = gridCount % gridsPerPage;
  const row = Math.floor(gridIndex / cols);
  const col = gridIndex % cols;

  if (gridIndex === 0 && gridCount > 0) {
    doc.addPage();
  }

  const startX = marginX + col * gridWidth;
  const startY = marginY + row * gridHeight;
  const fontStyle = fontStyles[gridCount % fontStyles.length];

 
  // Add background image inside the grid with some padding
  const imageCount = selectedImages.length;
  const imageIndex = index % imageCount;
  const imageUrl = selectedImages[imageIndex];

  // Make sure the image does not overlap the grid
  doc.addImage(imageUrl, 'JPEG', startX + 0, startY + 2, gridWidth -1, gridHeight - 1); 
  //in the above code gridWidth, gridHeight are used to increase and reduce space b/w Stickers

  
	  
	  
	  
	  
	  
	  
	  //upload Photo
	  
	  
	  // Only use uploaded photos
	const availablePhotos = photos.filter((photo) => photo); 
    const photoCount = availablePhotos.length;
  
  
   
   
   

	
	  
      // Add uploaded photos cyclically if any are available
	   if (photoCount > 0) {
    const photoIndex = index % photoCount;
    const photo = availablePhotos[photoIndex];
    
    // Draw a rounded rectangle before adding the image
    const rectX = startX + 8; // Adjusted for proper alignment
    const rectY = startY + 18;
    const rectWidth = 18;
    const rectHeight = 22;
    const borderRadius = 1;
    const borderThickness = 0.2;

    // The border area should surround the image
const imageWidth = rectWidth - 2 * borderThickness; // Adjusted for border
const imageHeight = rectHeight - 2 * borderThickness; // Adjusted for border
const imageX = rectX + borderThickness; // Adjusted X to start after the border
const imageY = rectY + borderThickness; // Adjusted Y to start after the border

doc.setLineWidth(borderThickness); // Border thickness
doc.setDrawColor(128, 0, 128); // Purple color (RGB: 128, 0, 128)
doc.roundedRect(rectX-1, rectY, rectWidth, rectHeight, borderRadius, borderRadius);

// Add the image on top of the rounded rectangle, making it fit perfectly within the border
//doc.addImage(photo, "JPEG", imageX-1.1, imageY-0.1, imageWidth-0.2, imageHeight-0.2);
doc.addImage(photo, "JPEG", imageX - 0.9, imageY + 0.1, imageWidth - 0.2, imageHeight - 0.2);


}

	  
	  //background of Photo
	  
	  const imageUrls = ['plain1.jpg', 'plain2.jpg', 'plain3.jpg', 'plain4.jpg'];
const imageIndex1 = index % imageUrls.length;
const imageUrl1 = imageUrls[imageIndex1];

doc.addImage(imageUrl1, 'JPEG', startX + 8, startY + 18, 17, 22);

	  
	
	  
	  

      doc.setFont(fontStyle.font, "normal");
      doc.setFontSize(fontStyle.size);
      doc.setTextColor(...fontStyle.color);
	  
	  
	  
	  
	  //superscript
	  
	  
    const processInput = (inputText) => {
    const cleanedInput = inputText.replace(/[ʰ-˿ᴀ-ᵿ]/g, "");

    return cleanedInput.replace(/\b(\d+)\b/g, (match, number) => {
        const num = parseInt(number, 10);
        let suffix = "th";

        if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
        else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
        else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";

        return `${num}${suffix}`;
    });
};

const drawTextWithSuperscript = (doc, text, startX, startY) => {
    const words = text.split(" "); // Split text into words for proper line rendering
    let currentX = startX;

    words.forEach((word) => {
        const match = word.match(/(\d+)(st|nd|rd|th)?/); // Separate number and suffix
        if (match) {
            const number = match[1];
            const suffix = match[2];

            // Draw the number
            doc.text(number, currentX, startY);
            currentX += doc.getTextWidth(number);

            if (suffix) {
                // Draw the suffix slightly higher and smaller
                const suffixOffset = 1.5; // Adjust for desired superscript height
                const originalFontSize = doc.getFontSize();
                doc.setFontSize(originalFontSize * 0.85); // Reduce font size for superscript
                doc.text(suffix, currentX, startY - suffixOffset);
                doc.setFontSize(originalFontSize); // Reset font size
                currentX += doc.getTextWidth(suffix);
            }
        } else {
            // Draw normal word
            doc.text(word, currentX, startY);
            currentX += doc.getTextWidth(word);
        }

        // Add space between words
        currentX += doc.getTextWidth(" ");
    });
    
    // To adjust the superscript size, modify the multiplier in `originalFontSize * 0.8`
    // For example, change to `originalFontSize * 0.7` for smaller superscripts.
};

// Process the input and prepare the text
const processedInput = processInput(formData.study1);
const lines = doc.splitTextToSize(processedInput, 180);

// Render additional text
const selection1Text = `${formData.selection1}: ${formData.name1}`;
const selection2AndInputText = `${formData.selection2}: ${processedInput}`;

//doc.text(selection1Text, startX+27, startY + 20);

// Render the `selection2` and `processedInput` text beside each other
const selection2Width = doc.getTextWidth(`${formData.selection2}: `);



      
       const label1 = `${formData.selection1}:`;
	   const label2 = `${formData.selection2}:`;
	   const label3 = `${formData.selection3}:`;
	   const label4 = `${formData.selection4}:`;
	   const label5 = `${formData.selection5}:`;
	   const label6 = `Subject:`;
	   
	   
	   
	   const maxLabelWidth = Math.max(
	   doc.getTextWidth(label1), 
	   doc.getTextWidth(label2), 
	   doc.getTextWidth(label3), 
	   doc.getTextWidth(label4), 
	   doc.getTextWidth(label5), 
	   doc.getTextWidth(label6)
	   );
	   
	   
	   // Define a common alignment starting point for the text after the colon
       
	   const textStartX = startX + 27 + maxLabelWidth + 0.5 // Add 5 for spacing after the colon
	   
	   
	   
	

      
 if (model === 'rect') {
  // RECT MODEL LOGIC
 // Function to draw text with specific color
      doc.setTextColor(labelColors[0]); 	  
       doc.text(label1, startX + 27, startY + 25);
	   doc.setTextColor(valueColors[0]);
       doc.text(`${formData.name1}`, textStartX, startY + 25);
	   doc.setDrawColor(lineColors[0]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 26, textStartX + 48, startY + 26);
	  
        
       doc.setTextColor(labelColors[1]); 	  
	   doc.text(label2, startX + 27, startY + 32);
	   doc.setTextColor(valueColors[1]);
       drawTextWithSuperscript(doc, processedInput, textStartX, startY + 32);
	   doc.setDrawColor(lineColors[1]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 33, textStartX + 48, startY + 33);
	  
	   
	   doc.setTextColor(labelColors[2]); 
       doc.text(label3, startX + 27, startY + 39);
	   doc.setTextColor(valueColors[2]);
	   const admNo1 = `${formData.AdmNo1}`; // First field data
       doc.text(admNo1, textStartX, startY + 39);

       // Calculate the width of the first field's text
       const admNo1Width = doc.getTextWidth(admNo1);

       // Place the second field right after the first field
       const semester = `${formData1.selection7}`; // Second field data
	   doc.setTextColor(labelColors[4]); 
       doc.text(semester, textStartX + admNo1Width + 2, startY + 39); // Add 5 for padding	   
	   doc.setDrawColor(lineColors[2]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 40, textStartX + 48, startY + 40);
	  
	   
       //doc.text(`${formData.AdmNo1}`, textStartX, startY + 39);
       doc.setTextColor(labelColors[3]); 
       doc.text(label4, startX + 27, startY + 46);
	   doc.setTextColor(valueColors[3]);
       doc.text(`${formData.School1}`, textStartX, startY + 46);
	   doc.setDrawColor(lineColors[3]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 47, textStartX + 48, startY + 47);
	  
       
	   //doc.text(label5, startX + 27, startY + 50);
       //doc.text(`${formData.comm}`, textStartX, startY + 50);
       doc.setTextColor(labelColors[4]); 
       doc.text(label6, startX + 27, startY + 52);
       doc.setTextColor(valueColors[4]);
       // Add the todo text at the specified coordinates
       doc.text(`${todo.text}`, textStartX, startY + 52);
	   doc.setDrawColor(lineColors[4]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 53, textStartX + 48, startY + 53);
	  

// Find the QR code canvas element by its ID
const qrCodeCanvas = document.getElementById(`qr-${index}`);

// If the QR code canvas exists, convert it to a PNG image and add it to the document
if (qrCodeCanvas) {
  const qrImage = qrCodeCanvas.toDataURL("image/png");
  doc.addImage(qrImage, "PNG", startX+8, startY + 41, 14, 14);
}
}
else if (model === 'round') {
  // ROUND MODEL LOGIC
   // Function to draw text with specific color
      doc.setTextColor(labelColors[0]); 	  
       doc.text(label1, startX + 27, startY + 28);
	   doc.setTextColor(valueColors[0]);
       doc.text(`${formData.name1}`, textStartX, startY + 28);
	   doc.setDrawColor(lineColors[0]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 29, textStartX + 48, startY + 29);
	  
        
       doc.setTextColor(labelColors[1]); 	  
	   doc.text(label2, startX + 27, startY + 34);
	   doc.setTextColor(valueColors[1]);
       drawTextWithSuperscript(doc, processedInput, textStartX, startY + 34);
	   doc.setDrawColor(lineColors[1]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 35, textStartX + 48, startY + 35);
	  
	   
	   doc.setTextColor(labelColors[2]); 
       doc.text(label3, startX + 27, startY + 40);
	   doc.setTextColor(valueColors[2]);
	   const admNo1 = `${formData.AdmNo1}`; // First field data
       doc.text(admNo1, textStartX, startY + 40);

       // Calculate the width of the first field's text
       const admNo1Width = doc.getTextWidth(admNo1);

       // Place the second field right after the first field
       const semester = `${formData1.selection7}`; // Second field data
	   doc.setTextColor(labelColors[4]); 
       doc.text(semester, textStartX + admNo1Width + 2, startY + 40); // Add 5 for padding	   
	   doc.setDrawColor(lineColors[2]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 41, textStartX + 48, startY + 41);
	  
	   
       //doc.text(`${formData.AdmNo1}`, textStartX, startY + 39);
       doc.setTextColor(labelColors[3]); 
       doc.text(label4, startX + 27, startY + 46);
	   doc.setTextColor(valueColors[3]);
       doc.text(`${formData.School1}`, textStartX, startY + 46);
	   doc.setDrawColor(lineColors[3]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 47, textStartX + 48, startY + 47);
	  
       
	   //doc.text(label5, startX + 27, startY + 50);
       //doc.text(`${formData.comm}`, textStartX, startY + 50);
       doc.setTextColor(labelColors[4]); 
       doc.text(label6, startX + 27, startY + 52);
       doc.setTextColor(valueColors[4]);
       // Add the todo text at the specified coordinates
       doc.text(`${todo.text}`, textStartX, startY + 52);
	   doc.setDrawColor(lineColors[4]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 53, textStartX + 48, startY + 53);
	   
	   
	   //for rounded images on the PDF
	   
	
	   //upload Photo
	  
	  
	  // Only use uploaded photos
	const availablePhotos = photos.filter((photo) => photo); 
    const photoCount = availablePhotos.length;
  
  
	  
    // Add uploaded photos cyclically if any are available
	  if (photoCount > 0) {
    const photoIndex = index % photoCount;
    const photo = availablePhotos[photoIndex];
    
    const rectX = startX + 8; // Adjusted for proper alignment
    const rectY = startY + 18;
    const rectWidth = 18;
    const rectHeight = 22;
    const borderRadius = 1;
    const borderThickness = 0.2;

    // The border area should surround the image
    const imageWidth = rectWidth - 2 * borderThickness-0.5; // Adjusted for border
    const imageHeight = rectHeight - 2 * borderThickness-0.5; // Adjusted for border
    const imageX = rectX + borderThickness-0.5; // Adjusted X to start after the border
    const imageY = rectY + borderThickness+0.2; // Adjusted Y to start after the border

    // Add the image (rectangle removed)
    doc.addImage(photo, "JPEG", imageX + 64, imageY -12, imageWidth , imageHeight - 3);
}


	   
	   
	   //ends here
	   
	  

// Find the QR code canvas element by its ID
const qrCodeCanvas = document.getElementById(`qr-${index}`);

// If the QR code canvas exists, convert it to a PNG image and add it to the document
if (qrCodeCanvas) {
  const qrImage = qrCodeCanvas.toDataURL("image/png");
  doc.addImage(qrImage, "PNG", startX+8, startY + 41, 14, 14);
}
}
else if (model === 'nop') {
  // NOP MODEL LOGIC (No image, slightly adjusted y-coordinates)
  // Function to draw text with specific color
      doc.setTextColor(labelColors[0]); 	  
       doc.text(label1, startX + 27, startY + 23);
	   doc.setTextColor(valueColors[0]);
       doc.text(`${formData.name1}`, textStartX, startY + 23);
	   doc.setDrawColor(lineColors[0]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 24, textStartX + 48, startY + 24);
	  
        
       doc.setTextColor(labelColors[1]); 	  
	   doc.text(label2, startX + 27, startY + 30);
	   doc.setTextColor(valueColors[1]);
       drawTextWithSuperscript(doc, processedInput, textStartX, startY + 30);
	   doc.setDrawColor(lineColors[1]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 31, textStartX + 48, startY + 31);
	  
	   
	   doc.setTextColor(labelColors[2]); 
       doc.text(label3, startX + 27, startY + 37);
	   doc.setTextColor(valueColors[2]);
	   const admNo1 = `${formData.AdmNo1}`; // First field data
       doc.text(admNo1, textStartX, startY + 37);

       // Calculate the width of the first field's text
       const admNo1Width = doc.getTextWidth(admNo1);

       // Place the second field right after the first field
       const semester = `${formData1.selection7}`; // Second field data
	   doc.setTextColor(labelColors[4]); 
       doc.text(semester, textStartX + admNo1Width + 2, startY + 37); // Add 5 for padding	   
	   doc.setDrawColor(lineColors[2]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 38, textStartX + 48, startY + 38);
	  
	   
       //doc.text(`${formData.AdmNo1}`, textStartX, startY + 39);
       doc.setTextColor(labelColors[3]); 
       doc.text(label4, startX + 27, startY + 44);
	   doc.setTextColor(valueColors[3]);
       doc.text(`${formData.School1}`, textStartX, startY + 44);
	   doc.setDrawColor(lineColors[3]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 45, textStartX + 48, startY + 45);
	  
       
	   //doc.text(label5, startX + 27, startY + 50);
       //doc.text(`${formData.comm}`, textStartX, startY + 50);
       doc.setTextColor(labelColors[4]); 
       doc.text(label6, startX + 27, startY + 51);
       doc.setTextColor(valueColors[4]);
       // Add the todo text at the specified coordinates
       doc.text(`${todo.text}`, textStartX, startY + 51);
	   doc.setDrawColor(lineColors[4]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 52, textStartX + 48, startY + 52);
	  

// Find the QR code canvas element by its ID
const qrCodeCanvas = document.getElementById(`qr-${index}`);

// If the QR code canvas exists, convert it to a PNG image and add it to the document
if (qrCodeCanvas) {
  const qrImage = qrCodeCanvas.toDataURL("image/png");
  doc.addImage(qrImage, "PNG", startX+8, startY + 40, 12, 12);
}
}
	
      gridCount += 1;
    });

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-"); // For safe filenames
    doc.save(`${formData.name1}_${timestamp}.pdf`);
  };

